import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    loading: false,

  },
  mutations: {
    setLoading(state, payload){
      state.loading = !!payload;
    },
    
  },
  actions: {
    
  },
  modules: {
  }
});

export default store;
